import { assign } from 'xstate';
import { Context } from '../bookingsMachine';

const filterBookings = assign<Context, any>((ctx, evt) => ({
    ...evt.data,
}));

export default filterBookings;
